import React from 'react';

import VerificationContent from './VerificationContent';
import {
  sendVerification,
  toggleEmailVerifyModal,
} from '../../../../actions/dashboard';
import styles from '../../../../styles/sass/components/Dashboard.module.scss';

interface Props {
  dispatch: Function;
  emailVerified: boolean;
  emailVerificationSent: boolean;
  token: string;
}

function EmailVerification(props: Props) {
  const { dispatch, emailVerified, emailVerificationSent, token } = props;

  if (emailVerified) {
    return (
      <div
        className={styles.verifyContainer}
        style={{
          background: 'rgba(135, 200, 100, 0.2)',
          border: '1px solid #195a50',
        }}
      >
        <VerificationContent
          icon="success"
          title="Your email address has been verified!"
        />
      </div>
    );
  } else if (!emailVerified && !emailVerificationSent) {
    return (
      <div className={styles.verifyContainer}>
        <VerificationContent
          icon="warning"
          title="Verify your email address"
          info="Keep your account safe by verifying your email address"
          buttonText="Send verification email"
          onClick={() => {
            dispatch(sendVerification('email', token));
          }}
        />
      </div>
    );
  } else if (!emailVerified && emailVerificationSent) {
    return (
      <div className={styles.verifyContainer}>
        <VerificationContent
          icon="paperPlane"
          title="Please check your email to finish verifying"
          buttonText="Enter verification code"
          onClick={() => dispatch(toggleEmailVerifyModal(true))}
        />
      </div>
    );
  }
  return null;
}

export default EmailVerification;
